import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Modal} from '../../components';
import * as Actions from '../../store/actions';
import {successfulModal} from 'assets/images/images';

function ReverificationSuccessModal({open, setOpen, retryType}) {
  const isRetry = retryType === 'retry';

  useEffect(() => {
    if (open) {
      setTimeout(() => setOpen(false), 3000);
    }
  }, [open, setOpen]);

  return (
    <Modal
      modalBg="bg-white80"
      modalTitle={'  '}
      show={open}
      onClose={setOpen}
      setOpen={setOpen}
      extraModalClasses="md:max-w-[500px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center"
      borderRadius="rounded-2xl"
    >
      <div className="flex flex-col justify-center items-center">
        <img src={successfulModal} alt="" className="w-28" />
        <p className="text-black text-[1.1rem] mt-4 mb-2">
          {isRetry ? 'Retry' : 'Re-verify '} initiated
        </p>
        <p className="text-[#8E90A9] text-sm text-center mt-1 w-4/6">
          You have successfully initiated a{' '}
          {isRetry ? ' verification retrial' : ' re-verification'}
        </p>
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(ReverificationSuccessModal);
